import { useEffect, useState } from "react";
import { throttle } from "utils/functions/common";

export default function useScrollVisibility(name?: string, threshold = 100) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (name !== 'wxdh') return
        const handleScroll = throttle(() => {
            setIsVisible(window.scrollY > threshold);
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            const banner = document.querySelector(`.banner`) as HTMLElement
            if (scrollTop > banner.clientHeight - 30) {
                setIsVisible(true)
            } else {
                setIsVisible(false)
            }
        }, 200);

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [threshold, name]);

    return isVisible;
}